import React, { useContext, useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { columns } from "./columns";
import { Box } from "@mui/material";
import { AuthContext } from "../../../context/authContext";
import { getAllProjects } from "./api";
import { useNavigate } from "react-router-dom";

export function AmsPage() {
  const [data, setData] = useState([]);
  const { accessToken } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      if (accessToken) {
        setData(await getAllProjects(accessToken));
      }
    }
    getData();
  }, [accessToken]);

  return (
    <Box sx={{ p: 2, overflowX: "auto" }}>
      <MaterialReactTable
        muiTableContainerProps={{
          sx: {
            overflowX: "auto",
            maxHeight: "none",
            minWidth: "900px",
          },
        }}
        data={data}
        columns={columns}
        defaultColumn={{ minSize: 20 }}
        enableEditing={false}
        layoutMode="grid"
        muiTableBodyRowProps={({ row }) => ({
          onClick: (event) => {
            const target = event.target;
            if (
              !target.closest(".MuiButtonBase-root") &&
              !target.closest("a")
            ) {
              navigate(`/ams/${row.original.id}`);
            }
          },
          sx: {
            cursor: "pointer",
          },
        })}
      />
    </Box>
  );
}
